module.exports = __webpack_public_path__ + "static/media/greygears.2e47a6da.png";